module.exports = __webpack_public_path__ + "static/york-college-c09915b37e4ea883dc7a1baff925f513.jpg";